import React from 'react';
import PropTypes from 'prop-types';
import Flexbox from 'flexbox-react';
import { css } from 'emotion';
import _ from 'lodash';
import InfoIcon from 'components/core/InfoIcon';
import RIEComboBox from 'components/core/editable/RIEComboBox';
import RIEToggle from 'components/core/editable/RIEToggle';
import ProcessField from 'components/core/fields/ProcessField';
import Constants from 'utils/Constants';
import ProcessUtils from 'utils/ProcessUtils';
import InfoMessages from 'components/core/help/InfoMessages';

/**
 * Field component for setting bin alignment for a dimension
 */
export default class BinAlignmentField extends ProcessField {

    static propTypes = Object.assign({
        coordinateSystemName: PropTypes.string,
        dimensionName: PropTypes.string
    }, ProcessField.propTypes);

    constructor(props) {
        super(props);

        const binAlignment = _.get(props.process, [...this.getBaseDimensionPath(), 'data_transformation', 'bin_alignment']);
        let editBinAlignment = false;
        if (binAlignment && binAlignment !== 'MIDDLE') {
            editBinAlignment = true;
        }

        this.state = {
            editBinAlignment
        };
        this.boldFont = css`font-weight:900;`;
    }

    getBaseDimensionPath = () => {
        return ['variable_retrieval', 'coordinate_systems', this.props.coordinateSystemName, 'dimensions', this.props.dimensionName];
    };

    getDimension = () => {
        return _.get(this.props.process, this.getBaseDimensionPath());
    };

    onEditBinToggleClicked = (fieldPath, value) => {
        this.setState({ editBinAlignment: value });
        if (!value) {
            // if toggled back to no, update the bin alignment back to middle
            ProcessUtils.updateField(this.props.process, [...this.getBaseDimensionPath(), 'data_transformation', 'bin_alignment'], 'MIDDLE');
        }
    };

    render() {
        const dimension = this.getDimension();
        const binAlignmentValue = Constants.getOptionById(dimension.data_transformation.bin_alignment, Constants.COORDINATE_SYSTEM_BIN_ALIGNMENTS);
        let component = '';

        const isRelevant = ProcessUtils.isRelevantTransformationParameter(this.props.process, 'alignment',
            [this.props.coordinateSystemName], dimension.name, null);

        if (isRelevant) {
            component = (
                <Flexbox flexDirection={'column'}>
                    <Flexbox flexDirection="row" alignItems="flex-start">
                        <Flexbox flexDirection={'row'} alignItems="center">
                            <InfoIcon message={InfoMessages.alignment}/>
                            <div className={this.boldFont}>Output data will be moved to center bin alignment. Do you
                                want to
                                change this setting?
                            </div>
                        </Flexbox>
                        <Flexbox margin="-1px 0 0 5px">
                            <RIEToggle
                                value={this.state.editBinAlignment}
                                textFalse="No"
                                textTrue="Yes"
                                fieldPath={['variable_retrieval']}
                                change={this.onEditBinToggleClicked}
                                radioGroupName="editBinAlignment"
                                formDisplay
                                isDisabled={!this.props.hasWritePermissions}
                                processId={this.props.process.name}
                            />
                        </Flexbox>
                    </Flexbox>

                    <Flexbox marginLeft="20px" marginTop="5px" flexDirection="column">
                        {this.state.editBinAlignment &&
                        <Flexbox padding="12px 15px 5px 15px" alignItems="center">
                            <div className={css`white-space:nowrap; margin-right:5px;`}>Bin Alignment:</div>
                            <RIEComboBox
                                className={css`max-width:200px;`}
                                value={binAlignmentValue}
                                options={Constants.COORDINATE_SYSTEM_BIN_ALIGNMENTS}
                                change={this.onFieldUpdated}
                                fieldPath={[...this.getBaseDimensionPath(), 'data_transformation', 'bin_alignment']}
                                formDisplay
                                isDisabled={!this.props.hasWritePermissions}
                                processId={this.props.process.name}
                            />
                        </Flexbox>
                        }
                    </Flexbox>
                </Flexbox>
            );
        }
        return component;
    }
}



// WEBPACK FOOTER //
// ./src/components/core/fields/BinAlignmentField.js